import { ActivatedRoute, Router } from '@angular/router';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { UserData } from '../../../@core/data/users';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { CartService } from 'app/services/cart/cart.service';
import jwtDecode from 'jwt-decode';
import { SiteSettings } from 'app/pages/settings/settings-page/site-settings';
import { ConfigurationService } from 'app/services/configurations/configurations.service';
import { Configuration } from 'app/models/configuration/configuration';
import { AuthService } from 'app/auth/auth.service';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import Validation from './validation';
import { AppComponent } from 'app/app.component';

@Component({
  selector: 'ultra-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();


  form: FormGroup;
  numberChars = new RegExp(/[\.\\\/$""'';#]/g, '');

  user: any;
  currentTheme = 'default';
  imagePath: string;
  categoriesButtonColor: string;
  siteSettings: any = SiteSettings.getInstance();

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private formBuilder: FormBuilder,
    private userService: UserData,
    private breakpointService: NbMediaBreakpointsService,
    private router: Router,
    public cartService: CartService,
    private route: ActivatedRoute,
    private service: ConfigurationService,
    public authService: AuthService,
    public el: ElementRef,
    public renderer: Renderer2
  ) {
    this._loadConfigServer();
    this.menuService.onItemClick().subscribe((event) => {
      event.item.title === 'Sair' ? this.leaveSession() : '';
    });
    route.queryParams.subscribe(data => {
      if (data.category || !data.filter)
        this.f.search.patchValue('');
    });
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      );

    this.themeService.onThemeChange().pipe(map(({ name }) => name),
      takeUntil(this.destroy$),
    ).subscribe(themeName => this.currentTheme = themeName);
    this.getLogoImage();

    this.cartService.loadCartSize();

    this.form = this.formBuilder.group({
      search: this.formBuilder.control("")
    })

  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  // faz a validação da pesquisa quando o usúario cola uma pesquisa com caracteres invalidos
  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text')
    let search = String.prototype.concat(this.f.search.value, pastedText)
    let newSearch = Validation.validationCharacters(search)
    this.f.search.patchValue(newSearch)
  }

  @HostListener('document:click', ['$event'])
  onclick($event) {
    if ($event.target.matches('.click') || $event.target.matches('.fas')) {
      document.getElementById('user-menu').click();
    }
  }

  getLogoImage() {
    let config = this.siteSettings.getConfiguration();
    if (config != null && config != undefined) {
      if (config.src.length < 60) {
        this._loadImageLocalStorage();
      } else {
        this.imagePath = config.src;
      }
    } else {
      this._loadImageLocalStorage();
    }
  }

  _loadImageLocalStorage() {
    var configLocal = localStorage.getItem('config');
    if (configLocal != null) this.imagePath = JSON.parse(configLocal).srcLogin;
  }

  _loadConfigServer(): void {
    this.service.getConfigurations().subscribe((value) => {
      this.siteSettings.setConfiguration(Configuration.fromJson(value.data));
      this.getLogoImage();
      this.setCategoriesColor();
    });
  }

  getUserName() {
    var temp = (jwtDecode(localStorage.getItem('accessToken')) as any);
    return `${temp.name}`;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  hideSidebar() {
    this.sidebarService.collapse('menu-sidebar');
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  leaveSession() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['auth/login']);
  }

  goToHome() {
    this.router.navigate(['pages/dashboard']);
  }

  goToOrder() {
    this.router.navigate(['pages/orders']);
  }

  checkoutNavigate() {
    this.router.navigate(['pages/checkout']);
  }

  goToSettings() {
    this.router.navigate(['pages/settings']);
  }

  pressedButton($event) {
    if ($event.code === 'Enter' || $event.code === 'NumpadEnter' || $event.key === 'Enter') {
      this.router.navigate(['pages/products'], { queryParams: { filter: this.f.search.value } });
    }
  }

  clickCategory() {
    AppComponent.isActivedCategory = !AppComponent.isActivedCategory;

    AppComponent.categoryOrientationY = 0;

    const containers = document.getElementById('menu');

    containers.style.transform = 'translateY(0px)';

    if (AppComponent.isActivedCategory) {
      // Desabilita o scroll da tela quando o dropdown de categorias estiver aberto
      this.preventWheel('hidden');
    } else {
      this.preventWheel('scroll');
    }
  }

  preventWheel(scroll: string) {
    var body = document.getElementById('body');
    var header = <HTMLElement>document.getElementsByClassName('fixed')[0];

    body.style.overflowY = scroll;

    if (scroll == 'hidden') {
      body.style.marginRight = '17px';
      header.style.marginRight = '17px';
    } else {
      body.style.margin = '0px';
      header.style.marginRight = '0px';
    }
  }

  setCategoriesColor(): void {
    this.categoriesButtonColor = this.siteSettings.getConfiguration().categoriesButtonColor;
  }
  
  getButtonStyle() {
    return { 'background-color': this.categoriesButtonColor, 'border-color': this.categoriesButtonColor };
  }
}
